export const PASS = 'PASS';
export const WARN = 'WARN';
export const DANGER = 'DANGER';